
import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../store";

import { isEnvBrowser, envBool } from "../utils/misc";

// adds font awesome pro icons
//import "../lib/fontawesome";

import { isEqual } from 'lodash';
// Apps
import LaptopUI from "./AppUI";

import { useSocketEventOutsideRequest } from "../hooks/useSocketEventOutsideRequest";
import { useSocketEvent } from "../hooks/useSocketEvent";

import { UserState, SET_PLAYERDATA } from "../reducers/userReducer";
import { PermissionType, PlayerType, HardMoneyState, SET_HOUSEDATA } from "../reducers/hardmoneyReducer";
import { UIState, SET_activeTab, SET_hidden, SET_slideClass, SET_schemeColor } from "../reducers/uiReducer";

import { socketRequest } from "../utils/socketRequest";
import { startHideEvent } from "../utils/startHideEvent";

import { throttle } from 'lodash';

const isDevMode: boolean = envBool(import.meta.env.VITE_ENV_SHOW_WEBSOCKET_CONNECTION);

// Determine connection mode for display
const getConnectionMode = (): { mode: string; icon: string; color: string } => {
    const isDev = import.meta.env.VITE_ENV_DEV_MODE === 'True';
    const useAWS = import.meta.env.VITE_USE_DEV_AWS === 'True';

    if (isDev) {
        if (useAWS) {
            return { mode: 'AWS Dev', icon: '🌩️', color: 'text-blue-400' };
        } else {
            return { mode: 'Local', icon: '💻', color: 'text-green-400' };
        }
    } else {
        return { mode: 'Production', icon: '🚀', color: 'text-purple-400' };
    }
};


// ipconfig

import { CONNECT_SOCKET, DISCONNECT_SOCKET, SEND_SOCKET_MESSAGE, GET_SOCKET_DATA, CLOSE_UI, OPEN_UI } from "../utils/socketActions";
import { getSocket } from "../utils/socketMiddleware";
import SlideToggle from "./GlobalComponents/SlideToggle/SlideToggle";

const AppHandler: React.FC = () => {

    const dispatch = useDispatch();
    const uiData = useSelector((state: RootState) => state.ui);
    const userData = useSelector((state: RootState) => state.user);

    // Get connection status from Redux - always up to date!
    const connected = uiData.socketConnected;

    useSocketEventOutsideRequest('GET_SOCKETDATA', (data: {
        houseName: string,
        sid: number,
    }) => {
        console.log("get socket data");
        if (data && data.houseName && data.sid) {
            dispatch(GET_SOCKET_DATA({
                houseName: data.houseName,
                sid: data.sid,
            }))
        } else {
            console.log("disconnect socket as no data");
            dispatch(DISCONNECT_SOCKET());
        };
    });
    // from client to set showing screen
    useSocketEventOutsideRequest('SET_HIDDEN', (data: {
        hide: boolean;
        sid: number;
        houseName: string;
    }) => {
        dispatch(
            SET_hidden(data.hide)
        );
        // if (data.hide) {
        //     if (data.sid && data.houseName) {
        //         dispatch(CLOSE_UI(
        //             {
        //                 sid: data.sid,
        //                 houseName: data.houseName,
        //             }
        //         ))
        //     };
        // } else {
        //     console.log("!data.hide");
        //     if (data.sid && data.houseName) {
        //         console.log("dispatch open ui");
        //         dispatch(OPEN_UI(
        //             {
        //                 sid: data.sid,
        //                 houseName: data.houseName,
        //             }
        //         ))
        //     } else {
        //         console.log("no data sid or houseName");
        //     };
        // };
    });

    useSocketEventOutsideRequest('SET_COLOR', (data: string) => {
        console.log("set color from outside request", data);
        dispatch(
            SET_schemeColor(data)
        );
    });

    useSocketEvent('SET_COLOR', (data: string) => {
        console.log("set color from any event", data);
        dispatch(
            SET_schemeColor(data)
        );
    });

    useSocketEventOutsideRequest('START_HIDE', (data: {
        sid: number;
        houseName: string;
    }) => {
        startHideEvent(dispatch);

        if (data.sid && data.houseName) {
            dispatch(CLOSE_UI(
                {
                    sid: data.sid,
                    houseName: data.houseName,
                }
            ))
        };
    });

    // Initial connection attempt after 500ms
    useEffect(() => {
        const initialTimeout = setTimeout(() => {
            if (!connected) {
                console.log("🔄 Attempting initial WebSocket connection...");
                dispatch(CONNECT_SOCKET({}));  // Use environment configuration
            }
        }, 0);

        return () => clearTimeout(initialTimeout);
    }, []); // Only run once on mount

    // Retry logic - only runs when disconnected
    useEffect(() => {
        if (!connected) {
            console.log("⚠️ Not connected, starting retry interval...");

            const retryInterval = setInterval(() => {
                console.log("⚠️ WebSocket not connected, retrying...");
                dispatch(CONNECT_SOCKET({}));  // Use environment configuration
            }, 10000); // Retry every 10 seconds

            return () => {
                console.log("🛑 Stopping retry interval (connected or unmounting)");
                clearInterval(retryInterval);
            };
        } else {
            console.log("✅ WebSocket is connected - no retry needed");
        }
    }, [connected, dispatch]); // Re-run when connection status changes

    // Send test messages after connection
    // const testMessagesSentRef = useRef<boolean>(false);
    // useEffect(() => {
    //     if (connected && !testMessagesSentRef.current) {
    //         testMessagesSentRef.current = true;
    //         console.log("📤 Connection established, scheduling test messages...");

    //         // Wait 5 seconds, then send SET_COLOR message
    //         const colorTimeout = setTimeout(() => {
    //             const socket = getSocket();
    //             if (socket && socket.readyState === WebSocket.OPEN) {
    //                 console.log("📤 Sending SET_COLOR test message with returnDev...");
    //                 // Send message with returnDev flag - server will echo it back without the flag
    //                 socket.send(JSON.stringify({
    //                     type: "SET_COLOR",
    //                     value: "255, 100, 150", // Test color
    //                     returnDev: true // Server will echo this back without returnDev
    //                 }));
    //             }
    //         }, 5000);

    //         // Wait 10 seconds total, then send uiUpdate message
    //         const uiUpdateTimeout = setTimeout(() => {
    //             const socket = getSocket();
    //             if (socket && socket.readyState === WebSocket.OPEN) {
    //                 console.log("📤 Sending uiUpdate test message with returnDev...");
    //                 // Send message with returnDev flag - server will echo it back
    //                 socket.send(JSON.stringify({
    //                     type: "uiUpdate",
    //                     uiData: { test: "data from test message" },
    //                     returnDev: true // Server will echo this back without returnDev
    //                 }));
    //             }
    //         }, 10000);
            
    //         // wait 15 secs, color through request
    //         const colorTimeout2 = setTimeout(async () => {
    //             console.log("📤 Sending SET_COLOR via socketRequest...");
    //             try {
    //                 const res = await socketRequest("SET_COLOR", {
    //                     value: "100, 200, 255", // Different test color
    //                     returnDev: true // Server will echo back with requestId
    //                 });
    //                 console.log("✅ SET_COLOR socketRequest response:", res);
    //             } catch (error) {
    //                 console.error("❌ SET_COLOR socketRequest failed:", error);
    //             }
    //         }, 15000);

    //         // send via request at 20 seconds
    //         const uiUpdate2Timeout = setTimeout(async () => {
    //             console.log("📤 Sending uiUpdate via socketRequest...");
    //             try {
    //                 const res = await socketRequest("uiUpdate", {
    //                     uiData: { test: "data from socketRequest" },
    //                     returnDev: true // Server will echo back with requestId
    //                 });
    //                 console.log("✅ uiUpdate socketRequest response:", res);
    //             } catch (error) {
    //                 console.error("❌ uiUpdate socketRequest failed:", error);
    //             }
    //         }, 20000);
            
    //         return () => {
    //             clearTimeout(colorTimeout);
    //             clearTimeout(colorTimeout2);
    //             clearTimeout(uiUpdateTimeout);
    //             clearTimeout(uiUpdate2Timeout);
    //         };
    //     }
    // }, [connected]);

    const lastSentRef = useRef<number>(0);
    const throttleTimeout = useRef<NodeJS.Timeout | null>(null);
  
    useEffect(() => {
        const now = Date.now();
        const timeSinceLastSend = now - lastSentRef.current;

        const sendUpdate = () => {
            if (connected) {
                console.log("sending update");
                lastSentRef.current = Date.now();
                dispatch(SEND_SOCKET_MESSAGE({
                    subType: "hello",
                    userData: userData,
                    uiData: uiData,
                }));
            };
        };
        
        if (timeSinceLastSend >= 500) {
            sendUpdate();
        } else {
            //console.log("update skipped")
            if (throttleTimeout.current) clearTimeout(throttleTimeout.current);
            throttleTimeout.current = setTimeout(sendUpdate, 500 - timeSinceLastSend);
        }

        return () => {
            if (throttleTimeout.current) clearTimeout(throttleTimeout.current);
        };
    }, [uiData]);

    // useEffect(() => {
    //     console.log('updating socket server'); 
    //     dispatch(SEND_SOCKET_MESSAGE(
    //         {
    //             subType: "hello",
    //             houseName: hardmoneyData.houseID,
    //             uiData: uiData,
    //             hardmoneyData: hardmoneyData,
    //             playerData: playerData,
    //         }
    //     ));
    // }, [uiData]);

    const handleKeyEvent = (event: KeyboardEvent) => {
        if (event.key === "Escape") {
            //console.log("pressing escape");
            startHideEvent(dispatch);
        }
    };

    useEffect(() => {
        window.addEventListener('keydown', handleKeyEvent);
        return () => {
            window.removeEventListener('keydown', handleKeyEvent);
        };
    }, []);


    useSocketEventOutsideRequest('SET_ALL_DATA', (data: {
        color: string;
        house: HardMoneyState;
        player: UserState;
    }) => {
        console.log("set all data", data.color);
        if (data) {
            dispatch(SET_schemeColor(data.color));
            dispatch(SET_HOUSEDATA(data.house));
            dispatch(SET_PLAYERDATA(data.player));
        }
    });


    // from client to set player data
    useSocketEventOutsideRequest('SET_PLAYERDATA', (data: UserState) => {
        //console.log("TRYING TO SET DATA");
        if (data) {
            dispatch(
                SET_PLAYERDATA({
                    ...data
                })
            );
        }
    });

    // from client to set house data
    useSocketEventOutsideRequest('SET_HOUSEDATA', (data: HardMoneyState) => {
        //console.log("TRYING TO SET DATA");
        if (data) {
            dispatch(
                SET_HOUSEDATA({
                    ...data
                })
            );
        }
    });

    if (uiData.hidden) return;

    return (
        // <>
        //     <SlideToggle
        //         show={!uiData.hidden}
        //         slideClass={uiData.slideClass}
        //     >
                <div
                    className="noSelect w-[100vw] min-h-screen box-border relative"
                    style={{
                        backgroundColor: isEnvBrowser() ? "gray" : "transparent",
                    }}
                >
                    <LaptopUI/>

                    
                    {isDevMode && (() => {
                        const connectionMode = getConnectionMode();
                        return (
                            <div className="absolute top-[1vh] left-[1vw] pointer-events-none flex flex-col gap-[0.5vh]">
                                <div className="flex items-center gap-[0.5vw]">
                                    <span className="text-[2vh] text-gray-400">
                                        WebSocket:
                                    </span>
                                    <span className={`text-[2vh] font-semibold ${connected ? "text-green-500" : "text-red-500"}`}>
                                        {connected ? "Connected" : "Not Connected"}
                                    </span>
                                </div>

                                <div className="flex items-center gap-[0.5vw]">
                                    <span className="text-[2vh] text-gray-400">
                                        Mode:
                                    </span>
                                    <span className={`text-[2vh] font-semibold ${connectionMode.color}`}>
                                        {connectionMode.icon} {connectionMode.mode}
                                    </span>
                                </div>
                            </div>
                        );
                    })()}
                        
                </div>
        //     </SlideToggle>
        // </>
    );
};

export default AppHandler;
